import get from 'lodash/get';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleLeadChannelCode = (
  vehicle: DashboardVehicle,
): string | undefined => get(vehicle, 'application.leadChannelCode');
